import { Card, CardContent, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const RefuelSummaryCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(0.5),
}));

export const RefuelSummaryCardContent = styled(CardContent)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1),
  '&:last-child': {
    paddingBottom: theme.spacing(1),
  },
}));

export const RefuelSummaryBody = styled(Stack)({
  '& *': {
    lineHeight: 1.5,
  },
});
